var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.code.users && _vm.code.users.length === 0
    ? _c("article", { staticClass: "message is-warning margin-top-md" }, [
        _vm.code.code
          ? _c("div", { staticClass: "message-body" }, [
              _vm._v(
                _vm._s(_vm.$t("codes.no_users_code", { code: _vm.code.code }))
              ),
              _c("br"),
              _vm._v(_vm._s(_vm.$t("codes.code_help"))),
            ])
          : _c("div", { staticClass: "message-body" }, [
              _vm._v(_vm._s(_vm.$t("codes.no_users"))),
              _c("br"),
              _vm._v(_vm._s(_vm.$t("codes.code_help"))),
            ]),
      ])
    : _vm.code.expiration &&
      _vm.daysDifference(_vm.code.expiration) <= _vm.daysLimit
    ? _c("article", { staticClass: "message is-warning margin-top-md" }, [
        _c("div", { staticClass: "message-body" }, [
          _vm._v(_vm._s(_vm.$t("codes.explain"))),
          _c("br"),
          _vm._v(
            _vm._s(
              _vm.$t("codes.expiration", {
                time: _vm.getDate(_vm.code.expiration),
              })
            )
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }